module.exports = __webpack_public_path__ + "media/images/emoticons/angry-7b1aef802a0ad2be2166bd0e4c4a34f5.gif";